import ROUTES from '../routes';
import WarningsReport from '../hoc/warning-report/warning-report';
import WarningsReportOverview from '../hoc/warning-report/overview';
import ListOfWarnings from '../hoc/warning-report/list';
import WarningDetails from '../hoc/warning-report/warning-details';
import CustomersWarningReport from '../hoc/warning-report/customers';
import CustomerWarningDetails from '../hoc/warning-report/customer-details';

const WarningsReportRoutes = {
  path: ROUTES.WARNING_REPORT,
  element: <WarningsReport />,
  children: [
    {
      path: ROUTES.WARNING_REPORT_OVERVIEW,
      element: <WarningsReportOverview />,
    },
    {
      path: ROUTES.WARNING_REPORT_CUSTOMERS,
      element: <CustomersWarningReport />,
      children: [
        {
          path: ROUTES.WARNING_REPORT_CUSTOMERS_DETAILS,
          element: <CustomerWarningDetails />,
        },
      ],
    },
    {
      path: ROUTES.WARNING_REPORT_LIST,
      element: <ListOfWarnings />,
      children: [
        {
          path: ROUTES.WARNING_REPORT_LIST_DETAILS,
          element: <WarningDetails />,
        },
      ],
    },
  ],
};

export default WarningsReportRoutes;
